// Debug utility for testing subscription creation
import { trialExtensionService } from '../services/trialExtensionService';
import { subscriptionService } from '../services/subscriptionService';

export class DebugSubscription {
  /**
   * Test subscription creation for a user
   */
  static async testSubscriptionCreation(userId: string) {
    try {
      console.log('🧪 DebugSubscription: Testing subscription creation for user:', userId);
      
      // Test 1: Check if user already has subscription
      console.log('🧪 Test 1: Checking existing subscription...');
      const existingSubscription = await subscriptionService.getUserSubscription(userId);
      console.log('🧪 Existing subscription:', existingSubscription);
      
      if (existingSubscription) {
        console.log('✅ User already has subscription, no need to create new one');
        return existingSubscription;
      }
      
      // Test 2: Create new subscription
      console.log('🧪 Test 2: Creating new subscription...');
      const userRegistrationDate = new Date();
      const newSubscription = await trialExtensionService.createOrUpdateExtendedTrialSubscription(
        userId,
        userRegistrationDate
      );
      console.log('🧪 New subscription created:', newSubscription);
      
      // Test 3: Verify subscription was created
      console.log('🧪 Test 3: Verifying subscription creation...');
      const verifySubscription = await subscriptionService.getUserSubscription(userId);
      console.log('🧪 Verification result:', verifySubscription);
      
      if (verifySubscription) {
        console.log('✅ Subscription creation and verification successful!');
        return verifySubscription;
      } else {
        console.error('❌ Subscription verification failed - subscription not found');
        return null;
      }
      
    } catch (error) {
      console.error('❌ DebugSubscription: Error during testing:', error);
      throw error;
    }
  }
  
  /**
   * Check subscription status for a user
   */
  static async checkSubscriptionStatus(userId: string) {
    try {
      console.log('🔍 DebugSubscription: Checking subscription status for user:', userId);
      
      const subscription = await subscriptionService.getUserSubscription(userId);
      
      if (!subscription) {
        console.log('❌ No subscription found for user');
        return null;
      }
      
      console.log('📊 Subscription details:', {
        id: subscription.id,
        userId: subscription.userId,
        planId: subscription.planId,
        status: subscription.status,
        startDate: subscription.startDate,
        endDate: subscription.endDate,
        trialExtensionReason: subscription.trialExtensionReason
      });
      
      return subscription;
      
    } catch (error) {
      console.error('❌ DebugSubscription: Error checking subscription status:', error);
      throw error;
    }
  }
}

// Make it available globally for browser console testing
if (typeof window !== 'undefined') {
  (window as any).DebugSubscription = DebugSubscription;
  (window as any).createExtendedTrial = async (userId: string) => {
    console.log('🧪 Manual extended trial creation for user:', userId);
    return await DebugSubscription.testSubscriptionCreation(userId);
  };
  console.log('🧪 DebugSubscription utility available in browser console as window.DebugSubscription');
  console.log('🧪 Manual trial creation available as window.createExtendedTrial(userId)');
}
